import { createFileRoute } from '@tanstack/react-router'
import { SettingsLayout } from '@/components/layout/settings'

export const Route = createFileRoute('/_auth/settings/')({
  component: SettingsPage,
  head: () => ({
    meta: [
      { name: 'SUL AI', content: 'SUL AI' },
      { title: 'SUL AI | Settings' },
    ],
  }),
})

function SettingsPage() {
  return <SettingsLayout />
}
